// Help Videos (Jill 2026-11-02): the how-to recordings on /help-videos.
//
// Each file sits in the private help-videos bucket at <audience>/<file>. The
// database decides who may play it (help_video_can_read, migration
// 20261102120000); this list only decides what the page shows, and the two
// must agree:
//   pilot    pilots
//   trainee  trainees and pilots (Jill 2026-11-02)
//   agent    the CLAA agent
// System admins see everything. The office sees nothing (the beta silo).
//
// Adding a video: prepare it (louder sound, smaller file), upload it to the
// audience's folder in the help-videos bucket, and add a line here.

// The trainee ride video came off 2026-11-03 (Jill): the Help guides
// (/help) cover it with pictures.
export const HELP_VIDEOS = [
    {
        path: "agent/claa-overview.mp4",
        title: "CLAA request queue",
        about: "Forwarding a ride request to the ship, recording the ship's answer, and where finished requests go.",
        length: "4:24",
    },
];

// Section headings, in page order.
export const AUDIENCES = [
    { key: "pilot", label: "For pilots" },
    { key: "trainee", label: "For trainees" },
    { key: "agent", label: "For the CLAA agent" },
];

export const audienceOf = (video) => String(video.path).split("/")[0];

// Which audience folders a login may watch. Mirrors help_video_can_read.
export function audiencesFor(roles = []) {
    const r = (roles || []).map((x) => String(x).toLowerCase());
    if (r.includes("system_admin")) return AUDIENCES.map((a) => a.key);
    const out = [];
    if (r.includes("pilot")) out.push("pilot");
    if (r.includes("pilot") || r.includes("trainee")) out.push("trainee");
    if (r.includes("agent")) out.push("agent");
    return out;
}

export function helpVideosFor(roles) {
    const ok = audiencesFor(roles);
    return HELP_VIDEOS.filter((v) => ok.includes(audienceOf(v)));
}
